import React, { useState, useEffect } from "react";
import { Drawer, IconButton, Skeleton } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import CancelIcon from "@mui/icons-material/Cancel";
import House from "../../Assets/images/apa1.png";
import StarRateIcon from "@mui/icons-material/StarRate";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import ShareIcon from "@mui/icons-material/Share";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BedOutlinedIcon from "@mui/icons-material/BedOutlined";
import BathtubOutlinedIcon from "@mui/icons-material/BathtubOutlined";
import SquareFootOutlinedIcon from "@mui/icons-material/SquareFootOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PaymentMethod from "./PaymentMethod";
import postService from "../../Services/post-service";
import getServices from "../../Services/get-service";
import { toast } from "react-toastify";
import RequestModal from "./RequestModal";
import SelectDuration from "./SelectDuration";

const drawerWidth = 650;
function AllApartClasses({
  open,
  handleClose,
  isProceedToPay = false,
  apartmentId,
  data,
  parentData,
  closeAllApartmentDrawer,
}) {
  const [paymentMethodOpen, setPaymentMethodOpen] = useState(false);
  const [durationModalOpen, setDurationModalOpen] = useState(false);
  const [loadingJoin, setLoadingJoin] = useState(false);
  const [requestModalOpen, setRequestModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isBookmarked, setIsBookmarked] = useState(false);
  const [loadingBookmark, setLoadingBookmark] = useState(false);
  const [apartmentDetails, setApartmentDetails] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [activeId, setActiveId] = useState(null);
  const [selectedTenure, setSelectedTenure] = useState(1);

  if (open && apartmentId !== activeId) {
    setActiveId(apartmentId);
    if (apartmentId) {
      setLoadingDetails(true);
    }
    setApartmentDetails(null);
  } else if (!open && activeId !== null) {
    setActiveId(null);
    setLoadingDetails(false);
    setApartmentDetails(null);
    setCurrentImageIndex(0);
  }

  useEffect(() => {
    if (open && apartmentId) {
      getServices
        .getApartmentClassById(apartmentId)
        .then((response) => {
          setLoadingDetails(false);
          if (response?.data?.statusCode === 200) {
            setApartmentDetails(response.data.data);
          }
        })
        .catch((error) => {
          setLoadingDetails(false);
          console.error(error);
        });
    }
  }, [open, apartmentId]);

  const displayData = apartmentDetails || data;
  const targetId =
    displayData?.apartmentClassId ||
    displayData?.id ||
    apartmentId ||
    data?.apartmentClassId ||
    data?.id;

  useEffect(() => {
    if (open && targetId) {
      getServices.getApartmentBuyLater(0, 100).then((res) => {
        if (res?.data?.statusCode === 200) {
          const savedApartments =
            res.data?.data?.savedApartmentClass || res.data?.data || [];
          const isSaved = savedApartments.some(
            (apt) =>
              String(apt.apartmentClassId) === String(targetId) ||
              String(apt.id) === String(targetId) ||
              String(apt.propertyId) === String(targetId),
          );
          setIsBookmarked(isSaved);
        }
      });
    }
  }, [open, targetId]);

  useEffect(() => {
    if (
      displayData?.isBookmarked !== undefined ||
      displayData?.isSaved !== undefined
    ) {
      setIsBookmarked(Boolean(displayData.isBookmarked || displayData.isSaved));
    }
  }, [displayData]);

  const images =
    displayData?.apartmentClassImagesDTOS?.length > 0
      ? displayData.apartmentClassImagesDTOS.map(
          (img) => img?.imageUrl || House,
        )
      : displayData?.apartmentImages?.length > 0
        ? displayData.apartmentImages.map((img) => img?.imageUrl || House)
        : [House, House, House, House];

  const handleProceedToPay = () => setDurationModalOpen(true);

  const handleRequestToJoin = () => {
    if (!apartmentId) return;
    setLoadingJoin(true);
    postService
      .requestToJoinApartment(apartmentId)
      .then((response) => {
        setLoadingJoin(false);
        if (response?.data?.statusCode === 200) {
          setRequestModalOpen(true);
        } else {
          toast.error(response?.data?.description);
        }
      })
      .catch((error) => {
        setLoadingJoin(false);
        toast.error(error?.response?.data?.description);
      });
  };

  return (
    <div>
      <Drawer
        anchor="right"
        variant="temporary"
        open={open}
        onClose={handleClose}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", sm: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: { xs: "100%", sm: drawerWidth },
            backgroundColor: "white",
          },
        }}
      >
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className=" p-4 flex justify-between items-center bg-white sticky top-0 z-10">
            <p className=" text-back-color2 font-[700] text-[18px]">
              Apartment details
            </p>
            <IconButton onClick={handleClose}>
              <CancelIcon className=" text-back-color2 text-[28px]" />
            </IconButton>
          </div>

          <div className=" px-6 pb-6 overflow-y-auto flex-grow">
            {loadingDetails ? (
              <div className="flex flex-col gap-4 mt-2">
                <Skeleton
                  variant="rounded"
                  width="100%"
                  height={250}
                  className="rounded-xl"
                />

                <div className="flex flex-col gap-3">
                  <div className="flex justify-between items-center">
                    <Skeleton variant="text" width="60%" height={32} />
                    <div className="flex gap-2">
                      <Skeleton variant="circular" width={32} height={32} />
                      <Skeleton variant="circular" width={32} height={32} />
                    </div>
                  </div>

                  <Skeleton variant="text" width="30%" height={24} />

                  <div className="flex gap-4">
                    <Skeleton variant="text" width="20%" height={20} />
                    <Skeleton variant="text" width="40%" height={20} />
                  </div>
                  <Skeleton
                    variant="rounded"
                    width="100%"
                    height={80}
                    className="rounded-xl"
                  />

                  <div className="flex justify-between items-center py-2 border-b border-[#CCF2E1]">
                    <Skeleton variant="text" width="30%" height={20} />
                    <Skeleton variant="text" width="15%" height={20} />
                  </div>

                  <div className="flex flex-col gap-2 mt-2">
                    <Skeleton variant="text" width="40%" height={24} />
                    <Skeleton variant="text" width="100%" />
                    <Skeleton variant="text" width="95%" />
                    <Skeleton variant="text" width="60%" />
                  </div>

                  <Skeleton
                    variant="rounded"
                    width="100%"
                    height={60}
                    className="rounded-xl"
                  />
                  <Skeleton
                    variant="rounded"
                    width="100%"
                    height={50}
                    className="rounded-xl"
                  />
                </div>
              </div>
            ) : (
              <>
                <div className=" mb-4 relative group">
                  <div className=" relative">
                    <img
                      src={images[currentImageIndex]}
                      alt="House"
                      className=" w-full rounded-xl object-cover h-[200px] md:h-[350px]"
                    />
                  </div>

                  <div className=" flex justify-center mt-3 gap-1">
                    {images.map((_, index) => (
                      <div
                        key={index}
                        onClick={() => setCurrentImageIndex(index)}
                        className={`h-1 rounded-full cursor-pointer transition-all duration-300 ${index === currentImageIndex ? "w-6 bg-gray-800" : "w-6 bg-gray-300"}`}
                      ></div>
                    ))}
                  </div>
                </div>

                <div className="flex flex-col mb-6 mt-2">
                  <div className="flex justify-between items-center mb-2">
                    <p className="font-[700] text-[24px] text-[#1E222B] mb-2 leading-tight">
                      {displayData?.apartmentName || ""}
                    </p>

                    <div className="flex items-center gap-3 mb-2">
                      <span className="text-[#00BC67] px-3 py-2 text-[12px] font-[600] rounded-md bg-[#E6F8F0]">
                        {displayData?.status || "Available"}
                      </span>
                      <ShareIcon
                        fontSize="small"
                        className="text-[#00BC67] cursor-pointer"
                      />
                      {loadingBookmark ? (
                        <CircularProgress
                          size={20}
                          className="text-[#00BC67] ml-2"
                        />
                      ) : isBookmarked ? (
                        <BookmarkIcon
                          fontSize="small"
                          className="text-[#00BC67] cursor-pointer ml-2"
                          onClick={() => {
                            if (loadingBookmark) return;
                            setLoadingBookmark(true);
                            const id = targetId;
                            postService.removeApartmentFromBookmark(id).then(
                              (response) => {
                                setLoadingBookmark(false);
                                if (response?.data?.statusCode === 200) {
                                  setIsBookmarked(false);
                                  toast.success(
                                    "Apartment removed from saved list",
                                    { autoClose: 1000 },
                                  );
                                } else {
                                  toast.error(response?.data?.description, {
                                    autoClose: 1000,
                                  });
                                }
                              },
                              (error) => {
                                setLoadingBookmark(false);
                                toast.error(
                                  error?.response?.data?.description,
                                  { autoClose: 1000 },
                                );
                              },
                            );
                          }}
                        />
                      ) : (
                        <BookmarkBorderIcon
                          fontSize="small"
                          className="text-gray-400 cursor-pointer ml-2"
                          onClick={() => {
                            if (loadingBookmark) return;
                            setLoadingBookmark(true);
                            const id = targetId;
                            postService.addApartmentBuyLater(id).then(
                              (response) => {
                                setLoadingBookmark(false);
                                if (response?.data?.statusCode === 200) {
                                  setIsBookmarked(true);
                                  toast.success(
                                    "Apartment saved successfully",
                                    { autoClose: 1000 },
                                  );
                                } else {
                                  toast.error(response?.data?.description, {
                                    autoClose: 1000,
                                  });
                                }
                              },
                              (error) => {
                                setLoadingBookmark(false);
                                toast.error(
                                  error?.response?.data?.description,
                                  { autoClose: 1000 },
                                );
                              },
                            );
                          }}
                        />
                      )}
                    </div>

                    <div className="">
                      <p className="text-[#00BC67] font-[700] text-[16px] leading-tight">
                        NGN <br /> {displayData?.price?.toLocaleString() || 0}
                        /year
                      </p>
                      <p className="text-[#00BC67] text-[10px] mt-1">
                        Inclusive of all taxes
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-4 mb-6">
                    {/* <p className="flex items-center gap-1 text-[13px] font-[500] text-[#1E222B]">
                      <StarRateIcon
                        className="text-[#A3D133]"
                        fontSize="small"
                      />
                      4.0 (26)
                    </p> */}
                    <p className="flex items-center gap-1 text-[13px] text-[#1E222B]">
                      <FmdGoodOutlinedIcon
                        fontSize="small"
                        className="text-[#808285]"
                      />
                      {displayData?.location || ""}
                    </p>
                  </div>

                  <div className="flex justify-around items-center bg-[#CCF2E1] rounded-xl py-4 px-2 mb-6">
                    <div className="flex flex-col items-center w-1/3">
                      <BedOutlinedIcon
                        fontSize="small"
                        className="mb-1 text-[#1E222B]"
                      />
                      <p className="text-[16px] font-[700] text-[#1E222B]">
                        {displayData?.bedRooms || 0}
                      </p>
                      <p className="text-[12px] font-[400] text-[#1E222B]">
                        Beds
                      </p>
                    </div>
                    <div className="flex flex-col items-center w-1/3 border-x border-[#1E222B]/10">
                      <BathtubOutlinedIcon
                        fontSize="small"
                        className="mb-1 text-[#1E222B]"
                      />
                      <p className="text-[16px] font-[700] text-[#1E222B]">
                        {displayData?.toilet || 0}
                      </p>
                      <p className="text-[12px] font-[400] text-[#1E222B]">
                        Baths
                      </p>
                    </div>
                    <div className="flex flex-col items-center w-1/3">
                      <SquareFootOutlinedIcon
                        fontSize="small"
                        className="mb-1 text-[#1E222B]"
                      />
                      <p className="text-[16px] font-[700] text-[#1E222B]">
                        {displayData?.size || "0m"}
                      </p>
                      <p className="text-[12px] font-[400] text-[#1E222B]">
                        Total Area
                      </p>
                    </div>
                  </div>

                  <div className="flex justify-between items-center border-b-2 border-b-[#CCF2E1] pb-3 mb-4">
                    <p className="text-[12px] font-[600] text-[#808285] uppercase tracking-wide">
                      MINIMUM STAY
                    </p>
                    <p className="text-[14px] font-[700] text-[#1E222B]">
                      1 year
                    </p>
                  </div>
                  <div className="mb-6">
                    <p className="text-[14px] font-[700] text-[#1E222B] mb-2">
                      Description
                    </p>
                    <p className="text-[13px] leading-[1.6] text-[#1E222B] font-[400]">
                      {displayData?.apartmentClassDetails}
                    </p>
                  </div>

                  <div className="bg-[#F8FAFC] rounded-xl p-4 flex gap-3 items-start mb-2">
                    <InfoOutlinedIcon
                      className="text-[#00BC67]"
                      sx={{ fontSize: 20, marginTop: "2px" }}
                    />
                    <p className="text-[#00BC67] text-[12px] font-bold leading-[1.5]">
                      All applicants are subject to landlord review and
                      background checks. Expected response time: 24-48 hours
                    </p>
                  </div>
                </div>

                {isProceedToPay ? (
                  <button
                    onClick={handleProceedToPay}
                    className="w-full bg-[#00BC67] transition-colors text-white font-[600] py-3.5 rounded-xl text-[16px]"
                  >
                    Proceed to pay
                  </button>
                ) : (
                  <button
                    onClick={handleRequestToJoin}
                    disabled={loadingJoin}
                    className={`w-full ${loadingJoin ? "bg-[#00BC67]" : "bg-[#00BC67]"} transition-colors text-white font-[600] py-3.5 rounded-xl text-[16px]`}
                  >
                    {loadingJoin ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      "Request to join"
                    )}
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </Drawer>
      {/* Payment Flow Modals */}
      <SelectDuration
        open={durationModalOpen}
        handleClose={() => setDurationModalOpen(false)}
        handleBack={() => setDurationModalOpen(false)}
        handleContinue={(durationStr) => {
          const tenure = parseInt(durationStr?.split(" ")[0]) || 1;
          setSelectedTenure(tenure);
          setDurationModalOpen(false);
          setPaymentMethodOpen(true);
        }}
        data={displayData}
      />
      <PaymentMethod
        open={paymentMethodOpen}
        handleClose={() => setPaymentMethodOpen(false)}
        data={{
          ...displayData,
          tenure: selectedTenure,
          rentedApartmentClassId: apartmentId || displayData?.id,
        }}
      />
      <RequestModal
        open={requestModalOpen}
        handleClose={() => {
          setRequestModalOpen(false);
          handleClose();
          if (closeAllApartmentDrawer) closeAllApartmentDrawer();
        }}
        apartmentId={apartmentId}
      />
    </div>
  );
}
export default AllApartClasses;
